
import {Vue, Component, Prop} from 'vue-property-decorator'
import {getAssetItem, getImageUrl} from 'src/utils/helpers';
import PremiumBanner from "./PremiumBanner.vue";


@Component({
  components: {PremiumBanner},
  methods: {
    getAssetItem,
    getImageUrl
  }
  })
export default class CatalogMiniature extends Vue {
  @Prop({required: true}) image: string;
  @Prop({required: true}) isLocked: boolean;
  @Prop({default: false}) isFromPopUp: boolean
  @Prop({default: false}) isTokatabArrangement: boolean;

  imgError: boolean = false;
}
